import Vue from 'vue'
import App from './App.vue'
import myrouter from './router'
import AxiosPlugin from './utils/axiosPlugin'
import Vuex from 'vuex'
// debugger

import { Image as VanImage } from 'vant';
import { Toast } from 'vant';
import { Lazyload } from 'vant';
import { NoticeBar } from 'vant';



Vue.use(NoticeBar);
Vue.use(VanImage);
Vue.use(Toast);
Vue.use(AxiosPlugin);
Vue.use(Lazyload);

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLogin:false,
    loginShow:false,
    cartCount:0,
    currentUser:{ID:0,Name:'',Tel:''},
  },
  mutations: {
    login (state) {
      state.isLogin=true
    },
    showLogin(state){
      state.loginShow=true;
    },
    hideLogin(state){
      state.loginShow=false
    },
    loginOut(state){
      state.isLogin=false;
    },
    setCartCount(state,num){
      state.cartCount=num;
    },
    setCurrentUser(state,data){
      state.currentUser=data;
    }
  }
})

Toast.setDefaultOptions('loading', { forbidClick: true });

myrouter.beforeEach((to, from, next) => {
  // Toast.loading("加载中")
  next();
});

myrouter.afterEach(() => {
  // iView.LoadingBar.finish();
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router:myrouter,
  store
}).$mount('#app')


